import type { OpenAPI } from "../../interfaces"
import SearchParams from "../searchParams"

export const groups = (api) => ({
  create(name, success, fail) {
    api.authenticatedRequest("POST", "/groups", { name }, success, fail)
  },
  get(id, success: (data: OpenAPI.GET<"/groups/{id}">["response"]) => void, fail) {
    api.authenticatedRequest("GET", `/groups/${id}`, null, success, fail)
  },
  update(
    id: string,
    data: OpenAPI.PUT<"/groups/{id}">["requestBody"],
    success: (data: OpenAPI.PUT<"/groups/{id}">["response"]) => void,
    fail,
  ) {
    api.authenticatedRequest("PUT", `/groups/${id}`, data, success, fail)
  },
  delete(id, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}`, null, success, fail)
  },
  join(id, userId, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/members/${userId}`, null, success, fail)
  },
  bulkJoin(id, data, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/members`, data, success, fail)
  },
  leave(id, userId, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}/members/${userId}`, null, success, fail)
  },
  bulkLeave(id: string, data: { users: string[] }, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}/members`, data, success, fail)
  },
  discover(success: (data: OpenAPI.GET<"/groups">["response"]) => void, fail) {
    api.authenticatedRequest("GET", "/groups", null, (data) => success?.(data.groups), fail)
  },
  getMembers(
    id: string,
    params: OpenAPI.GET<"/groups/{id}/members">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/groups/{id}/members">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString()
    api.authenticatedRequest("GET", `/groups/${id}/members?${queryParams}`, null, success, fail)
  },
  getChallenges(id, success, fail) {
    api.authenticatedRequest("GET", `/groups/${id}/challenges`, null, (data) => success?.(data.challenges), fail)
  },
  getActivityFeed(
    id: string,
    params: OpenAPI.GET<"/groups/{id}/activityfeed">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/groups/{id}/activityfeed">["response"]) => void,
    fail,
  ) {
    const queryParams = new SearchParams(params).toString()
    api.authenticatedRequest("GET", `/groups/${id}/activityfeed?${queryParams}`, null, success, fail)
  },
  postToActivityFeed(id, data, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/activityfeed`, data, success, fail)
  },
  updateActivityFeedPost(id, postId, data, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/activityfeed/${postId}`, data, success, fail)
  },
  deletePostFromActivityFeed(id, postId, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}/activityfeed/${postId}`, null, success, fail)
  },
  createAnnouncement(id, data, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/announcements`, data, success, fail)
  },
  getAnnouncements(id, success, fail) {
    api.authenticatedRequest("GET", `/groups/${id}/announcements`, null, (data) => success?.(data.announcements), fail)
  },
  deleteAnnouncement(id, announcementId, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}/announcements/${announcementId}`, null, success, fail)
  },
  updateAnnouncement(id, announcementId, data, success, fail) {
    api.authenticatedRequest("PUT", `/groups/${id}/announcements/${announcementId}`, data, success, fail)
  },
  getActivity(id, data, success, fail) {
    api.authenticatedRequest(
      "GET",
      `/groups/${id}/activity?freq=${data.freq}&recent=${data.recent}`,
      null,
      success,
      fail,
    )
  },
  getBusinesses(groupId, params, success, fail) {
    const queryParams = new SearchParams(params).toSafeString()
    api.authenticatedRequest("GET", `/groups/${groupId}/businesses${queryParams}`, null, success, fail)
  },
  follow(id, success, fail) {
    api.authenticatedRequest("POST", `/groups/${id}/followers`, null, success, fail)
  },
  unfollow(id, success, fail) {
    api.authenticatedRequest("DELETE", `/groups/${id}/followers`, null, success, fail)
  },
  followers(id, params, success, fail) {
    const queryParams = new SearchParams(params).toString()
    api.authenticatedRequest("GET", `/groups/${id}/followers?${queryParams}`, null, success, fail)
  },
  getMemberships(success, fail) {
    api.authenticatedRequest("GET", `/groups/memberships`, null, success, fail)
  },
  omni(id, query, success, fail) {
    const params = new SearchParams(query)
    api.authenticatedRequest("GET", `/groups/${id}/omni${params.toSafeString()}`, null, success, fail)
  },
})
